import { render } from "./PortView.vue?vue&type=template&id=1354377b"
import script from "./PortView.vue?vue&type=script&lang=js"
export * from "./PortView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__